<svelte:options accessors/>
<script>
    import NauiFilters from "../../../naui/components/NauiFilters.svelte";
    import Chart from 'chart.js/auto';
    import {onMount} from 'svelte';

    export let filters;

    let filtersCmpt;
    let canvasCumplimento;
    let canvasVentas;

    onMount(() => {
        const dataCumplimento = {
            labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
                label: '% de cumplimiento',
                data: [65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56],
                backgroundColor: 'rgb(73, 88, 103)',
                borderColor: 'rgb(73, 88, 103)',
                borderWidth: 1,
                barThickness: 45
            }]
        };
        const dataVentas = {
            labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
                label: 'Ventas',
                data: [65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56],
                backgroundColor: 'rgb(73, 88, 103)',
                borderColor: 'rgb(73, 88, 103)',
                borderWidth: 1,
                barThickness: 45
            }]
        };

        new Chart(canvasCumplimento, getConfig(dataCumplimento));
        new Chart(canvasVentas, getConfig(dataVentas));
    });

    function getConfig(data) {
        return {
            type: 'bar',
            data: data,
            options: {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            },
        };
    }
</script>

<div class="py-15">
    <NauiFilters bind:this={filtersCmpt} {filters} on:filtered/>
</div>

<div class="p-15 shadow radius 2">
    <h2 class="text-l mb-1">Cumplimento</h2>
    <canvas bind:this={canvasCumplimento} width="1200" height="300"></canvas>
</div>

<div class="p-15 shadow radius 2">
    <h2 class="text-l mb-1">Ventas</h2>
    <canvas bind:this={canvasVentas} width="1200" height="300"></canvas>
</div>